(function () {
  'use strict';

  document.querySelectorAll('.mm-builder').forEach(initBuilder);

  function initBuilder(root) {
    var minQty = parseInt(root.dataset.minQuantity, 10) || 4;
    var packVariantId = parseInt(root.dataset.packVariantId, 10);
    var submitBtn = root.querySelector('[data-mm-submit]');
    var errorEl = root.querySelector('[data-mm-error]');
    var countEl = root.querySelector('[data-mm-selected-count]');
    var fillEl = root.querySelector('[data-mm-progress-fill]');
    var cards = root.querySelectorAll('[data-mm-card]');
    var defaultButtonLabel = submitBtn.textContent.trim();

    // internal state per card, keyed by index — avoids re-reading the DOM
    // for every increment/decrement, which keeps this snappy on longer lists
    var quantities = new Array(cards.length).fill(0);

    cards.forEach(function (card, index) {
      var stepper = card.querySelector('[data-mm-stepper]');
      var valueEl = stepper.querySelector('[data-mm-qty-value]');
      var decreaseBtn = stepper.querySelector('[data-mm-decrease]');
      var increaseBtn = stepper.querySelector('[data-mm-increase]');
      var checkEl = card.querySelector('[data-mm-check]');
      var max = parseInt(card.dataset.maxPerProduct, 10) || minQty;
      var available = stepper.dataset.available === 'true';

      if (!available) {
        increaseBtn.disabled = true;
        decreaseBtn.disabled = true;
      }
      decreaseBtn.disabled = true; // starts at 0

      increaseBtn.addEventListener('click', function () {
        var total = getTotalSelected();
        if (quantities[index] < max && total < minQty) {
          quantities[index]++;
          render(index);
          onChange();
        }
      });

      decreaseBtn.addEventListener('click', function () {
        if (quantities[index] > 0) {
          quantities[index]--;
          render(index);
          onChange();
        }
      });

      function render(i) {
        valueEl.textContent = quantities[i];
        decreaseBtn.disabled = quantities[i] === 0;
        checkEl.classList.toggle('is-active', quantities[i] > 0);
      }
    });

    function getTotalSelected() {
      return quantities.reduce(function (sum, q) { return sum + q; }, 0);
    }

    function onChange() {
      var total = getTotalSelected();
      updateProgress(total);
      validate(total);
    }

    function updateProgress(total) {
      countEl.textContent = total;
      var pct = Math.min(100, Math.round((total / minQty) * 100));
      fillEl.style.width = pct + '%';
    }

    function validate(total) {
      var valid = total === minQty;
      submitBtn.disabled = !valid;

      if (total === 0) {
        setError('');
      } else if (total < minQty) {
        setError('Add ' + (minQty - total) + ' more to complete your pack of ' + minQty + '.');
      } else if (total > minQty) {
        setError("You've selected " + total + " — remove some to bring it back to " + minQty + '.');
      } else {
        setError('');
      }
    }

    function setError(message) {
      if (message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      } else {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function buildFlavorBreakdown() {
      var parts = [];
      cards.forEach(function (card, index) {
        if (quantities[index] > 0) {
          var stepper = card.querySelector('[data-mm-stepper]');
          parts.push(stepper.dataset.productTitle + ' x' + quantities[index]);
        }
      });
      return parts.join(', ');
    }

    submitBtn.addEventListener('click', function () {
      var total = getTotalSelected();
      if (total !== minQty) return;

      if (!packVariantId) {
        setError("Pack product isn't configured — contact the store owner.");
        return;
      }

      var breakdown = buildFlavorBreakdown();

      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: packVariantId,
              quantity: 1,
              properties: {
                'Your Flavors': breakdown
              }
            }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'Could not add to cart.');
            });
          }
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          setError(err.message);
          submitBtn.disabled = false;
          submitBtn.textContent = defaultButtonLabel;
        });
    });
  }
})();